import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";

function ConfirmationModal({
  isOpen,
  toggle,
  onConfirm,
  message,
  headingText,
  confirmText = "Yes",
  cancelText = "No",
}) {
  const [count, setCount] = useState("1");
  const [disableSubmit, setDisableSubmit] = useState(false);

  const invalidCount = (value) => {
    return !/^(?:[1-9]|[1-4][0-9]|50)$/.test(value);
  };

  useEffect(() => {
    setDisableSubmit(invalidCount(count));
  }, [count]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader>{headingText}</ModalHeader>
      <ModalBody className="d-flex align-items-center column-gap-3">
        {message}
        {headingText === "Confirm Module Duplication" && (
          <Input
            min={1}
            max={50}
            style={{ width: "100px" }}
            type="number"
            value={count}
            invalid={invalidCount(count)}
            onChange={(event) => setCount(event.target.value)}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={disableSubmit}
          color="primary"
          onClick={() => {
            toggle();
            onConfirm(count);
          }}
        >
          {confirmText}
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          {cancelText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmationModal;
